import { CoreIcon } from '../core-icon';
import callFillSVG from '../../assets/icons/call-fill.svg';
import type { IconProps } from '../core-icon';

export const CallFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={callFillSVG} {...props} />;
};
